import { useEffect, useMemo } from 'react';

import { getExistingSelectedValue } from '../utils/get-existing-selected-value';
import { AntSelectOption, OnSelectChange } from '../AntSelect';

export const useCheckValueExists = (value: any, options: AntSelectOption[], onChange?: OnSelectChange) => {
  const existingValue = useMemo(() => {
    return getExistingSelectedValue(value, options || []);
  }, [value, options]);

  useEffect(() => {
    if (Array.isArray(existingValue)) {
      if (existingValue.length !== value.length) {
        onChange?.(existingValue, options?.filter((option) => existingValue.includes(option)) || []);
      }
    } else if (value && !existingValue) {
      onChange?.(existingValue, []);
    }
  }, [existingValue, value, options, onChange]);

  return existingValue;
};
